// test1095
(1095 && 0);
